export default "__VITE_ASSET__547c0908__"